import { Component } from '@angular/core';

import { UntypedFormGroup } from '@angular/forms';
import { Fields } from 'src/app/shared/models/candidateprofile-genmodel';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  standalone: false,
})
export class InputComponent {
  field: Fields;
  group: UntypedFormGroup;
  constructor() {}
}
